// Generated by ReScript, PLEASE EDIT WITH CARE


function setQueryParam(url, queryParamName, value) {
  var searchParams = url.searchParams;
  searchParams.append(queryParamName, value);
  url.search = searchParams.toString();
  return url;
}

export {
  setQueryParam ,
}
/* No side effect */
